import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";
import TypeArticleService from "@/integrations/service/type-article.service";

export const useTypesArticle = () => {
  return useQuery({
    queryKey: queryKeys.typesArticle,
    queryFn: TypeArticleService.getAll,
  });
};

export const useCreateTypeArticle = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: TypeArticleService.create,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.typesArticle });
    },
  });
};

export const useUpdateTypeArticle = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: any) => TypeArticleService.update(id, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.typesArticle });
    },
  });
};

export const useDeleteTypeArticle = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: TypeArticleService.delete,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.typesArticle });
    },
  });
};
